var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "header" },
    [
      _vm._t("logo"),
      _vm._v(" "),
      _vm._t("dropdown-business"),
      _vm._v(" "),
      _vm._t("menu"),
      _vm._v(" "),
      _vm._t("search"),
      _vm._v(" "),
      _vm._t("options")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-786fbfab", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-786fbfab","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/layout/Header.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-786fbfab","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/layout/Header.vue
// module chunks = 0